import type {PricesSearchMatchScore} from "../../types/IPricesSearchModel";
import {normalizeSearchText} from "../normalize_search_text";

export const PRICES_SEARCH_MATCH_SCORE = {
    none: 0,
    /** Every token starts some word: "karoliny" → "Bł. Karoliny", "pawła" → "Jana Pawła II". */
    wordPrefix: 1,
    /** The whole phrase starts the text: "bie" → "Bielańska". */
    prefix: 2,
    exact: 3
} as const satisfies Record<string, PricesSearchMatchScore>;

const WORD_SEPARATOR = /[^a-z0-9]+/;

const toWords = (text: string): string[] => normalizeSearchText(text).split(WORD_SEPARATOR).filter(Boolean);

/**
 * How well `text` matches the typed tokens, ignoring case, diacritics and punctuation. A substring inside a word does
 * not count, which drops RCN's substring noise ("bie" → "Kobierzyńska", "Jana III Sobieskiego").
 */
export const scoreMatch = (text: string, tokens: readonly string[]): PricesSearchMatchScore => {
    const tokenWords = tokens.flatMap(toWords);
    if (tokenWords.length === 0) {
        return PRICES_SEARCH_MATCH_SCORE.none;
    }

    const textWords = toWords(text);
    const phrase = tokenWords.join(" ");
    const joinedText = textWords.join(" ");

    if (joinedText === phrase) {
        return PRICES_SEARCH_MATCH_SCORE.exact;
    }
    if (joinedText.startsWith(phrase)) {
        return PRICES_SEARCH_MATCH_SCORE.prefix;
    }

    return tokenWords.every((tokenWord) => textWords.some((word) => word.startsWith(tokenWord)))
        ? PRICES_SEARCH_MATCH_SCORE.wordPrefix
        : PRICES_SEARCH_MATCH_SCORE.none;
};

/** The highest score of any single token - a city matches when one of the typed words names it. */
export const scoreBestToken = (text: string, tokens: readonly string[]): PricesSearchMatchScore =>
    tokens.reduce<PricesSearchMatchScore>((best, token) => {
        const score = scoreMatch(text, [token]);

        return score > best ? score : best;
    }, PRICES_SEARCH_MATCH_SCORE.none);
import type {PricesSearchMatchScore} from "../../types/IPricesSearchModel";
import {normalizeSearchText} from "../normalize_search_text";

export const PRICES_SEARCH_MATCH_SCORE = {
    none: 0,
    /** Every token starts some word: "karoliny" → "Bł. Karoliny", "pawła" → "Jana Pawła II". */
    wordPrefix: 1,
    /** The whole phrase starts the text: "bie" → "Bielańska". */
    prefix: 2,
    exact: 3
} as const satisfies Record<string, PricesSearchMatchScore>;

const WORD_SEPARATOR = /[^a-z0-9]+/;

const toWords = (text: string): string[] => normalizeSearchText(text).split(WORD_SEPARATOR).filter(Boolean);

/**
 * How well `text` matches the typed tokens, ignoring case, diacritics and punctuation. A substring inside a word does
 * not count, which drops RCN's substring noise ("bie" → "Kobierzyńska", "Jana III Sobieskiego").
 */
export const scoreMatch = (text: string, tokens: readonly string[]): PricesSearchMatchScore => {
    const tokenWords = tokens.flatMap(toWords);
    if (tokenWords.length === 0) {
        return PRICES_SEARCH_MATCH_SCORE.none;
    }

    const textWords = toWords(text);
    const phrase = tokenWords.join(" ");
    const joinedText = textWords.join(" ");

    if (joinedText === phrase) {
        return PRICES_SEARCH_MATCH_SCORE.exact;
    }
    if (joinedText.startsWith(phrase)) {
        return PRICES_SEARCH_MATCH_SCORE.prefix;
    }

    return tokenWords.every((tokenWord) => textWords.some((word) => word.startsWith(tokenWord)))
        ? PRICES_SEARCH_MATCH_SCORE.wordPrefix
        : PRICES_SEARCH_MATCH_SCORE.none;
};

/** The highest score of any single token - a city matches when one of the typed words names it. */
export const scoreBestToken = (text: string, tokens: readonly string[]): PricesSearchMatchScore =>
    tokens.reduce<PricesSearchMatchScore>((best, token) => {
        const score = scoreMatch(text, [token]);

        return score > best ? score : best;
    }, PRICES_SEARCH_MATCH_SCORE.none);
